import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  callStaffServicesAPI,
  getServicesAPI,
  getSettingsShopCustomAPI,
} from 'redux/api/settingsApi';
import { settingsAction } from 'redux/slices/settingsSlice';

function* getSettingsShopCustomSaga(
  action: PayloadAction<{ shop_id: number; bill_id: number | string; appName: string }>
) {
  try {
    const res: AxiosResponse = yield call(getSettingsShopCustomAPI, action.payload);
    const { data } = res;
    if (data) {
      yield put(settingsAction.getSettingsShopCustomSuccess(data));
    }
  } catch (error) {}
}
function* getServicesSaga(action: PayloadAction<{ shop_id: number; appName: string }>) {
  const { shop_id, appName } = action.payload;
  try {
    const res: AxiosResponse = yield call(getServicesAPI, { shop_id, appName });
    const { status, data } = res;
    if (status == 200) {
      yield put(settingsAction.getServicesSuccess(data));
    }
  } catch (error) {
    yield put(settingsAction.getServicesFailed);
  }
}
function* callStaffServiceSaga(
  action: PayloadAction<{ token: string; data: any; appName: string }>
) {
  const { token, data, appName } = action.payload;
  try {
    const res: AxiosResponse = yield call(callStaffServicesAPI, token, data, appName);
    const { status } = res;
    if (status == 200) {
      yield put(settingsAction.callStaffServicesSuccess());
    }
  } catch (error: any) {
    const apiMessage = error.response?.data?.message || error.message;

    yield put(settingsAction.callStaffServicesFailed(String(apiMessage)));
  }
}
export default function* settingsSaga() {
  yield takeLatest(settingsAction.getSettingsShopCustom.type, getSettingsShopCustomSaga);
  yield takeLatest(settingsAction.getServices.type, getServicesSaga);
  yield takeLatest(settingsAction.callStaffServices.type, callStaffServiceSaga);
}
